import { render, staticRenderFns } from "./IconPDF.vue?vue&type=template&id=728d39c4&scoped=true&"
import script from "./IconPDF.vue?vue&type=script&lang=js&"
export * from "./IconPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728d39c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728d39c4')) {
      api.createRecord('728d39c4', component.options)
    } else {
      api.reload('728d39c4', component.options)
    }
    module.hot.accept("./IconPDF.vue?vue&type=template&id=728d39c4&scoped=true&", function () {
      api.rerender('728d39c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconPDF.vue"
export default component.exports